import React from "react";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import Icon from "@amzn/meridian/icon";
import chevronRightSmallTokens from "@amzn/meridian-tokens/base/icon/chevron-right-small";
import { InspectionTemplate } from "src/data/types";
import { Box, Card } from "@amzn/meridian";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "src/store/store";
import {
  getTemplateById,
  setSelectedInspectionTemplate,
} from "src/store/dataSlice";
export type Template = {
  questionIds: string[];
  templateId: string;
  templateName: string;
};
type TemplateDisplayCardProps = {
  inspectionTemplate: Template;
};
const TemplateDisplayCard = ({
  inspectionTemplate,
}: TemplateDisplayCardProps) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  return (
    <Card
      spacingInset="200 400"
      onClick={() => {
        dispatch(setSelectedInspectionTemplate(inspectionTemplate));
        dispatch(getTemplateById(inspectionTemplate.templateId));
        navigate(`/templates/${inspectionTemplate.templateId}`);
      }}
    >
      <Row alignmentHorizontal="justify" height={64}>
        <Column spacing="200">
          <Row>
            <Text type="b300">{inspectionTemplate.templateName}</Text>
          </Row>
          <Row>
            <Text color="secondary" type="b100">
              {"siteCode"}
            </Text>
            <Text
              color="secondary"
              type="b100"
            >{`${inspectionTemplate.questionIds.length} Checks`}</Text>
          </Row>
        </Column>
        <Icon tokens={chevronRightSmallTokens} />
      </Row>
    </Card>
  );
};

export default TemplateDisplayCard;
